const DOLLARS = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

export const formatDollars = amount => DOLLARS.format(Number(amount) || 0)
